import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import { morphSection, updateCarDrawer } from '@theme/section-renderer';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.cartItemsComponent = this.querySelector('cart-items-component');
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.cartItemsComponent.clearCartErrors();
    this.cartItemsComponent.querySelectorAll('mb-subscription-toggle').forEach(toggle => {
      toggle.enableInput();
    });
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/**
 * Event handler for checkout button click in cart drawer ( includes preupsell logic )
 */
document.addEventListener('click', function(event) {
  const checkoutButton = event.target.closest('#checkout');
  if (checkoutButton) {
    let preUpsellDetails = JSON.parse(checkoutButton.dataset.cartPreupsellInfo);
    if (preUpsellDetails && preUpsellDetails.preUpsellLink) {
      window.location.href = preUpsellDetails.preUpsellLink;
    } else {
      window.location.href = '/checkout';
    }
  }
});

// Handle page show event to re-render cart drawer if the page is loaded from cache
window.addEventListener('pageshow', async function(event) {
  const currPAGE = window.location.pathname;
  const checkRedirect = currPAGE.includes('preupsell')
  // Redirect to home page if cart is empty(edge case for PostPU navigation)
  if(checkRedirect) {
    const cartResponse = await fetch('/cart.js');
    const data = await cartResponse.json();
    if(data.item_count == 0) {
      window.location.replace('/');
    }
  }
  if(event.persisted) {
    const cartItemComponent = this.document.querySelector('cart-items-component');
    const sectionID = cartItemComponent.dataset.sectionId;
    const updatedCARTSECTIONS = await this.fetch(`/?sections=${sectionID}`);
    const CART_SECTION_RESPONSE = await updatedCARTSECTIONS.json();
    updateCarDrawer(CART_SECTION_RESPONSE[sectionID]);
    window.initiateAddlFGPromotion(true);
  }
})